import {useMemo} from 'react';

import {useDepartmentLevelsQuery} from 'modules/decisionsNext/components/BaseFilter/api/departmentLevels.generated';

export const useDepartmentLevelOptions = (skip?: boolean) => {
  const {data, loading} = useDepartmentLevelsQuery({skip, disableSkipSetsLoadingState: true});

  const options = useMemo(
    () =>
      (data?.departments.levels || []).map(level => ({
        id: level.level,
        label: `Level ${level.name}`,
        shortLabel: level.name,
        isDefault: level.isDefault,
      })),
    [data?.departments.levels]
  );

  return {
    options,
    loading,
  };
};
